import React from 'react';
import { DabaduProgressBars } from 'sharedComponents/linearProgress';
import { StepperHeaderProps } from './dynamicStepperFormInterface';

const StepperHeader: React.FC<StepperHeaderProps> = ({ heading, currentStep = 0, stepConfig = [] }) => {
  return (
    <div className='dy-stepper-form__header'>
      <div className='form-group'>
        {/* <label className='control-label text-center w-100'>{heading}</label> */}
        <DabaduProgressBars value={((currentStep + 1) / stepConfig.length) * 100} />
      </div>
    </div>
  );
};

export default StepperHeader;
